import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'updateCurrentEmailTemplate'

export default (data) => (asyncAction(
  name,
  CampaignsService.updateCurrentEmailTemplate,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/updateCurrentEmailTemplate.js